export const addQuestionSelector = ({ prospectQuestions }) => prospectQuestions;
